import React from 'react';
import { motion } from 'framer-motion';
import visionImage from '../assets/aboutUs/vision.png'; // Replace with your vision image

const About = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className="max-w-6xl mx-auto px-6 py-16"
    >
      <h1 className="text-4xl md:text-5xl font-bold text-blue-600 mb-10 text-center">
        About Us
      </h1>

      {/* Mission Section */}
      <div className="grid md:grid-cols-2 gap-10 items-center bg-blue-50 rounded-xl p-8 mb-16 shadow-md">
        {/* Text Content */}
        <div>
          <div className="flex items-center mb-6 space-x-4">
            <div className="bg-blue-600 text-white rounded-full p-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </div>
            <h2 className="text-2xl font-semibold text-blue-700">Our Mission</h2>
          </div>

          <p className="text-gray-700 text-lg leading-relaxed">
            <strong className="text-blue-600">MyMarketingBuddy</strong> is on a mission to revolutionize customer communication for small and medium businesses using WhatsApp automation tools like <strong>QuickBot</strong> and <strong>Zappy</strong>.
            <br />
            <br />
            We aim to make{' '}
            <span className="font-semibold text-blue-700">
              marketing smarter, faster, and more accessible
            </span>{' '}
            — without needing a tech team.
          </p>
        </div>

        {/* Image */}
        <div>
          <img
            src={require('../assets/aboutUs/mission.png')} // Replace with your image
            alt="Mission Illustration"
            className="w-full h-auto rounded-lg shadow-md object-cover"
          />
        </div>
      </div>

      {/* Vision Section (flipped layout and styled like Mission) */}
      <div className="grid md:grid-cols-2 gap-10 items-center bg-blue-50 rounded-xl p-8 mb-16 shadow-md">
        {/* Image */}
        <div>
          <img
            src={visionImage}
            alt="Vision Illustration"
            className="w-full h-auto rounded-lg shadow-md object-cover"
          />
        </div>

        {/* Text Content */}
        <div>
          <div className="flex items-center mb-6 space-x-4">
            <div className="bg-blue-600 text-white rounded-full p-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 7V3m8 4V3m-8 4h8m-9 8h10m-11 4h12"
                />
              </svg>
            </div>
            <h2 className="text-2xl font-semibold text-blue-700">Our Vision</h2>
          </div>

          <p className="text-gray-700 text-lg leading-relaxed">
            We envision a future where businesses of all sizes can run sophisticated marketing operations without writing a single line of code.
            <br />
            <br />
            <strong className="text-blue-600">MyMarketingBuddy</strong> is not just a tool — it's a partner for growth. We’re here to level the playing field with automation that works for everyone.
          </p>
        </div>
      </div>

      <h2 className="text-2xl font-semibold text-gray-800 mb-10 text-center">
        Hear from Our Happy Clients
      </h2>
      <div className="grid md:grid-cols-3 gap-8 mb-16">
        {/* Testimonial 1 – Beauty Sensation */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300">
          <div className="flex items-center space-x-4 mb-4">
            {/* Replace with brand logo */}
            <img src={require('../assets/aboutUs/logos/beauty_sensation_logo.png')} alt="Beauty Sensation" className="h-12 w-12 rounded-full object-cover" />
            <div>
              <h3 className="text-lg font-semibold text-blue-600">Princy Rajpal</h3>
              <p className="text-gray-500 text-sm">Founder, Beauty Sensation</p>
            </div>
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">
            We've been using <strong>MyMarketingBuddy</strong> for over 6 months now, and it’s transformed the way we market our salon. Campaigns are easier to launch, responses are quicker, and engagement is up like never before.
          </p>
        </div>

        {/* Testimonial 2 – Polish It */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300">
          <div className="flex items-center space-x-4 mb-4">
            {/* Replace with brand logo */}
            <img src={require('../assets/aboutUs/logos/polish_it_logo.png')} alt="Polish It" className="h-12 w-12 rounded-full object-cover" />
            <div>
              <h3 className="text-lg font-semibold text-blue-600">Uma Kataria</h3>
              <p className="text-gray-500 text-sm">Owner, Polish It</p>
            </div>
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">
            <strong>Zappy</strong> is the best WhatsApp automation tool I've ever used. It feels like I have a personal assistant that never sleeps. Booking reminders, flash offers, and re-engagements are all on autopilot now.
          </p>
        </div>

        {/* Testimonial 3 – Sun Electricals */}
        <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300">
          <div className="flex items-center space-x-4 mb-4">
            {/* Replace with brand logo */}
            <img src={require('../assets/aboutUs/logos/sun_elec_logo.jpg')} alt="Sun Electricals" className="h-12 w-12 rounded-full object-cover" />
            <div>
              <h3 className="text-lg font-semibold text-blue-600">Himanshu</h3>
              <p className="text-gray-500 text-sm">Owner, Sun Electricals</p>
            </div>
          </div>
          <p className="text-gray-700 text-sm leading-relaxed">
            Since we started using <strong>QuickBot</strong>, the quality of our incoming calls has improved significantly — fewer missed calls, more serious leads. It's like switching from chaos to clarity.
          </p>
        </div>
      </div>


      {/* Team Section */}
      {/* <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
        Meet the Founders
      </h2> */}
      {/* <div className="grid md:grid-cols-2 gap-8 mb-16">

        <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
          <h3 className="text-xl font-semibold text-blue-600">Aniket Motwani</h3>
          <p className="text-gray-600 mt-2">Co-founder & Product Strategist</p>
          <p className="text-gray-500 text-sm mt-2">
            Focused on simplifying tech and building user-first marketing solutions.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-md p-6 text-center hover:shadow-lg transition-shadow duration-300">
          <h3 className="text-xl font-semibold text-blue-600">Vinit Lalwani</h3>
          <p className="text-gray-600 mt-2">Co-founder & Engineering Lead</p>
          <p className="text-gray-500 text-sm mt-2">
            Loves building scalable systems that enable automation at every step.
          </p>
        </div>
      </div> */}
    </motion.section>
  );
};

export default About;
